// import {
//   Alert,
//   Button,
//   Snackbar
// } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import SellerAccountForm from "./SellerAccountForm";
// import SellerLoginForm from "./SellerLoginForm";
// import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
// import { useLocation } from "react-router-dom";

// const BecomeSeller = () => {
//   const [activeStep, setActiveStep] = useState(0);
//   const dispatch = useAppDispatch();
//   const location = useLocation();
//   const [isLoginPage, setIsLoginPage] = useState(false);
//   const { sellerAuth } = useAppSelector(store => store);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);

//   const handleCloseSnackbar = () => setSnackbarOpen(false);

//   useEffect(() => {
//     if (sellerAuth.sellerCreated || sellerAuth.error || sellerAuth.otpSent) {
//       setSnackbarOpen(true);
//       console.log("store ", sellerAuth.error);
//     }
//   }, [sellerAuth.sellerCreated, sellerAuth.error, sellerAuth.otpSent]);

//   return (
//     <div className="min-h-screen flex flex-col md:flex-row bg-gray-50">
//       {/* Form Section */}
//       <section className="w-full md:w-1/2 flex justify-center items-center p-10">
//         <div className="w-full max-w-md bg-white shadow-lg rounded-md p-8">
//           {!isLoginPage ? <SellerAccountForm /> : <SellerLoginForm />}

//           <div className="mt-10 space-y-2">
//             <h1 className="text-center text-sm font-medium">
//               {isLoginPage && "Don't"} Have an account?
//             </h1>
//             <Button
//               onClick={() => setIsLoginPage(!isLoginPage)}
//               fullWidth
//               sx={{ py: "11px" }}
//               variant="outlined"
//             >
//               {isLoginPage ? "Register" : "Login"}
//             </Button>
//           </div>
//         </div>
//       </section>

//       {/* Image / Info Section */}
//       {/* <section className="hidden md:flex md:w-1/2 justify-center items-center p-10">
//         <div className="max-w-lg text-center space-y-6">
//           <div className="space-y-2 font-bold">
//             <p className="text-2xl">Join the Marketplace Revolution</p>
//             <p className="text-lg text-teal-500">Boost Your Sales Today</p>
//           </div>
//           <img src="/seller.jpg" alt="Become a Seller" className="w-full rounded-md" />
//         </div>
//       </section> */}

//       <section
//   className="hidden md:flex md:w-1/2 justify-center items-center p-10"
//   style={{
//     backgroundImage: "url('/seller.jpg')",
//     backgroundSize: "cover",
//     backgroundPosition: "center",
//   }}
// >
//   {/* <div className="max-w-lg text-center space-y-6 bg-black bg-opacity-50 p-6 rounded-md text-white">
//     <div className="space-y-2 font-bold">
//       <p className="text-2xl">Join the Marketplace Revolution</p>
//       <p className="text-lg text-teal-300">Boost Your Sales Today</p>
//     </div>
//   </div> */}
// </section>

//       {/* Snackbar */}
//       <Snackbar
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={handleCloseSnackbar}
//       >
//         <Alert
//           onClose={handleCloseSnackbar}
//           severity={sellerAuth.error ? "error" : "success"}
//           variant="filled"
//           sx={{ width: "100%" }}
//         >
//           {sellerAuth.error
//             ? sellerAuth.error
//             : sellerAuth.sellerCreated
//             ? sellerAuth.sellerCreated
//             : "OTP sent to your email!"}
//         </Alert>
//       </Snackbar>
//     </div>
//   );
// };

// export default BecomeSeller;

import {
  Alert,
  Button,
  Snackbar
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import SellerAccountForm from "./SellerAccountForm";
import SellerLoginForm from "./SellerLoginForm";
import { useAppDispatch, useAppSelector } from "../../../Redux Toolkit/Store";
import { useLocation } from "react-router-dom";

const BecomeSeller = () => {
  const [activeStep, setActiveStep] = useState(0);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [isLoginPage, setIsLoginPage] = useState(false);
  const { sellerAuth } = useAppSelector(store => store);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCloseSnackbar = () => setSnackbarOpen(false);

  useEffect(() => {
    if (sellerAuth.sellerCreated || sellerAuth.error || sellerAuth.otpSent) {
      setSnackbarOpen(true);
      console.log("store ", sellerAuth.error);
    }
  }, [sellerAuth.sellerCreated, sellerAuth.error, sellerAuth.otpSent]);

  return (
    <div
      className="min-h-screen flex justify-center items-center bg-cover bg-center relative"
      style={{
        backgroundImage: "url('/seller.jpg')",
      }}
    >
      {/* Optional dark overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>

      {/* Form Content */}
      <div className="relative z-10 w-full max-w-md bg-white bg-opacity-90 backdrop-blur-md rounded-md shadow-lg p-8 mx-4">
        {/* Commented out to disable registration form */}
        {/* {!isLoginPage ? <SellerAccountForm /> : <SellerLoginForm />} */}
        <SellerLoginForm />

        <div className="mt-10 space-y-2">
          <h1 className="text-center text-sm font-medium">
            {/* {isLoginPage && "Don't"} Have an account?
            Don't have an account? */}
          </h1>
          {/* Disable toggle to registration */}
          {/* <Button
            onClick={() => setIsLoginPage(!isLoginPage)}
            fullWidth
            sx={{ py: "11px" }}
            variant="outlined"
          >
            {isLoginPage ? "Register" : "Login"}
          </Button> */}
        </div>
      </div>

      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={sellerAuth.error ? "error" : "success"}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {sellerAuth.error
            ? sellerAuth.error
            : sellerAuth.sellerCreated
            ? sellerAuth.sellerCreated
            : "OTP sent to your email!"}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default BecomeSeller;

